export default __webpack_public_path__ + "static/media/bottles.186fdd03.svg";